import MicroModal from 'micromodal';

class GenericPopup {

    constructor() {
        MicroModal.init();
    }
}

const modalTriggers = document.querySelectorAll('[data-micromodal-trigger]');

if (modalTriggers) {
    window.popups = new GenericPopup();
}

export default GenericPopup;